
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserProfileRecord } from './user-profile-record';

import { AlertMessagesConfig } from 'config/alert-messages.config';
import { User } from 'app/users/user';

export const mockUser: User = {
  firstName: 'Catherine',
  middleName: '',
  lastName: 'Miller',
  email: 'a@b.com',
};

export type UserProfileRecordResponse = {
  data: UserProfileRecord
}

export interface IUserService {
  getEmailAddress(): string;
}

@Injectable()
export class UserService implements IUserService {
  private _user = mockUser;
  private _profile!: UserProfileRecord;

  constructor(
    // private http: HttpClient,
    // private alertMessages: AlertMessagesConfig
  ) {
  }

  // fetchProfile(): Observable<UserProfileRecord> {
  //   console.log (`fetch Profile`);
  //   return this.http
  //   // .get<UserProfileRecordResponse>('/usan/api/account').pipe(
  //       .get<UserProfileRecordResponse>('http://localhost:9084/usanapi/account').pipe(
  //     map((response: UserProfileRecordResponse) => {
  //       this.setProfile(response.data);
  //       return this.profile;
  //     }));
  // }

  setProfile(profile: UserProfileRecord) {
    this._profile = profile;
    return this;
  }

  get profile(): UserProfileRecord {
    // if(!this._profile) {
    //   this.fetchProfile();
    // }
    return this._profile;
  }

  getEmailAddress(): string {
    return this._profile.email;
  }

  isInGroup(group: string): boolean {
    if (!this._profile) {
      return false;
    }

    if (this._profile.groups.match(group)) {
      return true;
    } else {
      return false;
    }
  }

  isLoggedIn(): boolean {
    if(this._profile && this._profile.uniqueId && this._profile.uniqueId.trim() !== '') {
      return true;
    }

    return false;
  }

  setUser(user: User): UserService {
    this._user = user;
    return this;
  }

  get user(): User {
    return this._user;
  }

  setEmail(email: string): UserService {
    this.user.email = email;
    return this;
  }
}
